import { render } from "./strategi.vue?vue&type=template&id=ccb5aafa"
import script from "./strategi.vue?vue&type=script&lang=js"
export * from "./strategi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__